<section class="seasons-page">
  <app-admin-page-header [title]="title" [subtitle]="subtitle">
    <div header-actions>
      <button class="admin-btn admin-btn--primary" (click)="createMission()">Novo Template</button>
    </div>
  </app-admin-page-header>

  <div class="admin-feedback admin-feedback--error" *ngIf="feedbackError">
    {{ feedbackError }}
  </div>

  <div class="seasons-toolbar admin-surface">
    <input
      type="text"
      class="admin-input"
      [(ngModel)]="searchTerm"
      placeholder="Buscar por nome ou descrição"
      (keydown.enter)="applyFilters()" />

    <select class="admin-input" [(ngModel)]="gameFilter">
      <option value="">Todos os Jogos</option>
      <option value="LEAGUE_OF_LEGENDS">League of Legends</option>
      <option value="COUNTER_STRIKE">Counter-Strike</option>
    </select>

    <select class="admin-input" [(ngModel)]="statusFilter">
      <option value="">Todos os status</option>
      <option value="true">Ativo</option>
      <option value="false">Inativo</option>
    </select>

    <div class="seasons-toolbar__actions">
      <button class="admin-btn admin-btn--primary" (click)="applyFilters()">Filtrar</button>
      <button class="admin-btn admin-btn--secondary" (click)="clearFilters()">Limpar</button>
    </div>
  </div>

  <div class="admin-surface seasons-table">
    <p-table 
      [value]="missions" 
      [loading]="isLoading"
      [lazy]="true" 
      [paginator]="true" 
      [rows]="rowsPerPage" 
      [totalRecords]="totalMissions" 
      (onLazyLoad)="onLazyLoad($event)">
      <ng-template pTemplate="header">
        <tr>
          <th>ID</th>
          <th>Jogo</th>
          <th>Nome</th>
          <th>Métrica</th>
          <th>Tier</th>
          <th>Mult.</th>
          <th>Status</th>
          <th>Ações</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-mission>
        <tr>
          <td>#{{ mission.id }}</td>
          <td>{{ mission.game }}</td>
          <td>{{ mission.name }}</td>
          <td>{{ mission.metric }}</td>
          <td>{{ mission.tier }}</td>
          <td>{{ mission.multiplier }}x</td>
          <td>
            <span [style.color]="mission.is_active ? '#7bf1a8' : '#ff6f7d'">
              {{ mission.is_active ? 'Ativo' : 'Inativo' }}
            </span>
          </td>
          <td>
            <button class="admin-btn admin-btn--secondary" (click)="detailMission(mission.id)">
              Gerenciar
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>